import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { gql } from "@apollo/client";
import { createPageInfo } from "./helper";
export var typeDef = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  type InformarionConnection {\n    data: [Link]\n    pageInfo: PageInfo\n  }\n  type Query {\n    informations(key: String, offset: Int, limit: Int): InformarionConnection\n  }\n"])));
export var resolvers = {
  Query: {
    informations: function () {
      var _informations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_parent, _ref, _ref2) {
        var key, offset, limit, dataSources, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                key = _ref.key, offset = _ref.offset, limit = _ref.limit;
                dataSources = _ref2.dataSources;
                _context.next = 4;
                return dataSources.linkSet.linkSet(key, offset, limit);

              case 4:
                res = _context.sent;
                return _context.abrupt("return", {
                  data: res === null || res === void 0 ? void 0 : res.links,
                  pageInfo: createPageInfo({
                    offset: offset,
                    limit: limit,
                    count: res.total_count
                  })
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function informations(_x, _x2, _x3) {
        return _informations.apply(this, arguments);
      }

      return informations;
    }()
  }
};